// This is a component about calls to api
// refer to documentation
// @author lamrpalex

import axios from 'axios';
import saveAs from 'file-saver';
import { getCookieValue } from '../utilities/cookiesUtil';

/**
 * the underscore is disable to make easy the transition to no underscore
 */
/* eslint-disable no-param-reassign, no-underscore-dangle */

const URL = `${process.env.REACT_APP_SERVER_URL}`;

// This function takes a project's id and returns a OPENAPI specification
function getOpenApi(projectId, dispatch) {
  const config = {
    url: `${URL}/api/project/${projectId}/getOpenApi`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };

  axios
    .request(config)
    .then(
      (response) => {
        // console.log(response);
        return response;
      }
      // TODO this should return the openApi ?
      // console.log(response);
    )
    .catch((err) => {
      if (err.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
    });
}

// This function updates a project fields. As input is the project to be updated
// TODO: this needs refactoring the fields should
function updateProject(project, dispatch) {
  // creating the config of the request depending on
  const config = {
    url: `${URL}/api/project/${project._id}/updateProject`,
    method: 'PUT',
    data: {
      name: project.name,
      description: project.description,
      type_app: project.type_app,
      color_theme: project.colorTheme,
      type_font: project.fontType,
      invited_people: project.invited_people,
      pages: project.pages,
      services: project.services,
      data_elements: project.data_elements,
      customBlocks: project.customBlocks,
      image: project.image,
      actions: project.actions,
      annotations: project.annotations,
      _id: project._id,
      date: project.date,
      status: project.status
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };

  axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      if (err.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
    });
}

// This function updates a project fields. As input is the project to be updated
// TODO: this needs refactoring the fields should
async function updateProject2(projectId, projectFields) {
  // creating the config of the request depending on
  const config = {
    url: `${URL}/api/project/${projectId}/updateProject`,
    method: 'PUT',
    data: { ...projectFields },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };

  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}
async function updateProject3(projectId, projectFields) {
  // creating the config of the request depending on
  const config = {
    url: `${URL}/api/project/${projectId}`,
    method: 'PUT',
    data: { ...projectFields },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };

  return axios
    .request(config)
    .then((response) => {
      // console.log('hello from update 3', response);
      return response;
    })
    .catch((err) => {
      // console.log('hello from update 3', err);
      throw err;
    });
}
/*  This function sends a request to get a dl link of the project's back end
 *  code. It takes a project and returns a link to download the zipped code.
 */
function getServerDLLink(project) {
  // creating the config of the request depending on
  const config = {
    url: `${URL}/api/project/${project._id}/getServerLink`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };

  return axios
    .request(config)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}
/*  This function sends a request to get a dl link of the project's back end
 *  code. It takes a project and returns a link to download the zipped code.
 */
function getFrontsdkDLLink(project) {
  // creating the config of the request depending on
  const config = {
    url: `${URL}/api/project/${project._id}/getSDKLink`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };

  return axios
    .request(config)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

/*  This function calls a url and receives a response containing the bytes of
 * the zipped code source
 */
function downloadUrlSaveAsZip(url, dispatch) {
  // creating the config of the request depending on
  const config = {
    url,
    method: 'GET',
    responseType: 'arraybuffer'
  };
  return axios
    .request(config)
    .then((response) => {
      const blob = new Blob([response.data], { type: 'application/zip' });
      return saveAs(blob, `${response.config.url.slice(response.config.url.lastIndexOf('/') + 1)}`);
    })
    .catch((err) => {
      if (err.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
      throw err;
    });
}

/*  This function calls a url and pushes content of created project to github
 */
function syncToGithub(url, downloadLink, repoPreName, dispatch) {
  // creating the config of the request depending on
  const config = {
    url,
    method: 'GET',
    params: { downloadLink, repoPreName }
  };
  return axios
    .request(config)
    .then((response) => response.data.pathToStatus)
    .catch((err) => {
      if (err.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
      throw err;
    });
}

/*  This function calls a url and checks for the status of our push to github
 */
function syncToGithubStatus(url, pathToStatus, dispatch) {
  // creating the config of the request depending on
  const config = {
    url,
    method: 'GET',
    params: { pathToStatus }
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((err) => {
      if (err.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
      throw err;
    });
}

async function getUsersProjects(userId) {
  return axios
    .get(`${URL}/api/project/getData`, {
      headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` },
      params: { registeredUserId: userId }
    })
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

/**
 * This function takes a new project and creates the new resource.
 * @param {json} project a new project
 * @return {json} response a project
 */
async function createProject(project) {
  const config = {
    url: `${URL}/api/project/createProject`,
    method: 'POST',
    data: {
      name: project.name,
      description: project.description,
      type_app: project.type_app,
      color_theme: project.color_theme,
      type_font: project.type_font,
      invited_people: project.invited_people,
      registeredUserId: project.owner,
      annotations: project.annotations,
      pages: project.pages,
      date: project.date,
      services: project.services,
      data_elements: project.data_elements,
      customBlocks: project.customBlocks
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function deleteProject({ user, project }) {
  const config = {
    url: `${URL}/api/project/deleteProject`,
    method: 'DELETE',
    params: {
      registeredUserId: user._id,
      _id: project._id
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function deleteProjectsPendingInvitations({ user, project }) {
  const config = {
    url: `${URL}/api/project/deleteProjectsPendingInvitations`,
    method: 'DELETE',
    params: {
      registeredUserId: user._id,
      _id: project._id,
      userLogin: user.login,
      projectName: project.name
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function loginWithUserPass({ username, password }) {
  const config = {
    url: `${URL}/api/authenticate/loginAccount`,
    method: 'POST',
    data: {
      username,
      password
    }
  };
  return axios
    .request(config)
    .then((response) => response.data.retrievedUser)
    .catch((err) => {
      throw err;
    });
}
/**
 * @params {Object} {_id:"ObectId"},{name:"username"},{email:"email"}
 */
async function getUserWithParam(params) {
  const config = {
    url: `${URL}/api/user/getUser`,
    method: 'GET',
    params,
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function getUserField(field) {
  const config = {
    url: `${URL}/api/user/${field}`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function updateUser(user) {
  const config = {
    url: `${URL}/api/user/`,
    method: 'PUT',
    data: { user },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function createMessage(message) {
  const config = {
    url: `${URL}/api/message/createMessage`,
    method: 'POST',
    data: message,
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function getMessage(messageId) {
  const config = {
    url: `${URL}/api/message/${messageId}`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function deleteUsersMessage({ userId, messageId, projectId }) {
  const config = {
    url: `${URL}/api/message/${messageId}`,
    method: 'DELETE',
    params: {
      messageId,
      userId,
      projectId
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function getInvitersMessages({ inviterLogin, projectName, user }) {
  const config = {
    url: `${URL}/api/user/sendedmessages`,
    method: 'GET',
    params: {
      inviterLogin,
      projectName,
      user
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function deleteMember({ projectId, userId }) {
  const config = {
    url: `${URL}/api/project/${projectId}/deleteMember`,
    method: 'PUT',
    params: {
      projectId,
      userId
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function doAction({ url, method }) {
  const config = {
    url,
    method,
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function createPage(page) {
  const config = {
    url: `${URL}/api/page/createPage`,
    method: 'POST',
    data: { ...page },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then(({ data = {} }) => {
      const { _id: pageId = data._id, ...page } = data;
      page.pageId = pageId;
      return page;
    })
    .catch((err) => {
      throw err;
    });
}

async function readPage({ pageId: paramPageId }) {
  const config = {
    url: `${URL}/api/page/getPage/${paramPageId}`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then(({ data = {} }) => {
      const { _id: pageId = data._id, ...page } = data;
      page.pageId = pageId;
      return page;
    })
    .catch((err) => {
      throw err;
    });
}

async function updatePage(page) {
  const config = {
    url: `${URL}/api/page/updatePage/${page.pageId}`,
    method: 'PUT',
    data: { ...page },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then(({ data = {} }) => {
      const { _id: pageId = data._id, ...updatedPage } = data;
      updatedPage.pageId = pageId;
      return updatedPage;
    })
    .catch((err) => {
      throw err;
    });
}

async function deletePage(pageId, projectId) {
  const config = {
    url: `${URL}/api/page/deletePage/${pageId}`,
    method: 'DELETE',
    params: { projectId },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function createDuplicatePages(pagesIds) {
  const config = {
    url: `${URL}/api/page/createDuplicatePages`,
    method: 'POST',
    data: { pagesIds },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function latestPageTimestamp(paramPageId) {
  const config = {
    url: `${URL}/api/page/latest/${paramPageId}`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

/**
 * Field params are not yet implemented correctly
 * @params {Object} {field:[strings]} field to populate
 */
async function readProject(projectId, params) {
  const config = {
    url: `${URL}/api/project/${projectId}`,
    method: 'GET',
    params,
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

/**
 * Field params are not yet implemented correctly
 * @param {object} fileName the file name to be downloaded
 */
async function getFrontSDKArtifact(projectId, { fileName }) {
  const config = {
    url: `${URL}/api/project/${projectId}/file/sdk`,
    method: 'GET',
    params: { fileName },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

/**
 * Send to trigger the githubaction dispatch
 * @param {string} projectId the project id
 */
async function deployAProject(projectId) {
  const config = {
    url: `${URL}/api/project/${projectId}/deployGithubAction`,
    method: 'POST',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

/**
 * Send to list workpackage actions
 * @param {string} projectId the project id
 */
async function listProjectActions(projectId) {
  const config = {
    url: `${URL}/api/project/${projectId}/actions`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

/**
 * Call to get All deployConfigs
 * @returns {Array} Returns an array of DeployConfig
 */
async function getAllDeployConfigs() {
  const config = {
    url: `${URL}/api/deployConfig/getAll`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

/**
 * Call to get All the available deployConfigs
 * @returns {Object} Returns a DeployConfig
 */
async function getDeployConfig(id) {
  const config = {
    url: `${URL}/api/deployConfig/${id}`,
    method: 'GET',
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

/**
 * Call to get all metrics from cyclopt
 * @param {string} repoName for given repo
 * @returns {Object} returns metrics
 */
async function analyzeProject(repoName) {
  const config = {
    url: `${URL}/api/analyzeProject`,
    method: 'GET',
    params: {
      repoName
    },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

async function deleteProjectRepo(projectName, projectOwner) {
  const config = {
    url: `${URL}/api/deleteProjectRepo`,
    method: 'DELETE',
    params: { projectName, projectOwner },
    headers: { Authorization: `Bearer ${getCookieValue('accessToken')}` }
  };
  return axios
    .request(config)
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
}

const apiService = {
  getOpenApi,
  updateProject,
  createProject,
  getServerDLLink,
  getFrontsdkDLLink,
  downloadUrlSaveAsZip,
  getUsersProjects,
  loginWithUserPass,
  deleteProject,
  getUserWithParam,
  updateProject2,
  createMessage,
  getMessage,
  getUserField,
  doAction,
  createPage,
  readPage,
  updatePage,
  deletePage,
  latestPageTimestamp,
  deleteUsersMessage,
  readProject,
  getFrontSDKArtifact,
  updateUser,
  syncToGithub,
  syncToGithubStatus,
  getAllDeployConfigs,
  getDeployConfig,
  analyzeProject,
  deployAProject,
  deleteProjectRepo,
  getInvitersMessages,
  deleteMember,
  deleteProjectsPendingInvitations,
  createDuplicatePages,
  listProjectActions,
  updateProject3
};

export default apiService;
